export default function formatToISO8601Date(date: Date): string {
  return `${
    new Date(date.getTime() - date.getTimezoneOffset() * 60000)
      .toISOString()
      .split("T")[0]
  }`;
}
